import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="main-footer">
          <strong>
            Copyright &copy; 2025 <a href="#">SECURE TOPUP CONNECT</a>
          </strong>
        </footer>
      </div>
    );
  }
}
